import getInstance from "../config/api";

export default class Report {
  static async fetchAllDownloads(params) {
    const instance = getInstance();
    const { data } = await instance.get("/downloads", { params });
    return data;
  }
  static async fetchAllReportSolicitationJob(params) {
    const instance = getInstance();
    const { data } = await instance.get("/downloads/job-solicitation", {
      params,
    });
    return data;
  }

  static async fetchAllDailyReportSolicitationJob(params) {
    const instance = getInstance();

    const { data } = await instance.get(
      "/downloads/daily-job-sales-loss-insurance?typeReport=22",
      {
        params,
      }
    );
    return data;
  }

  static async fetchExtractionHistory(IdReport) {
    const instance = await getInstance();
    const { data } = await instance.get(
      `/downloads/extraction-history?IdReport=${IdReport}`
    );
    return data;
  }

  static async fetchCSVReport(IdReport) {
    const instance = getInstance();
    const data = await instance.get(
      `/downloads/csv?IdReport=${IdReport.IdReport}`
    );
    return data;
  }
  static async fetchCSVSolicitation(body) {
    const instance = getInstance();
    const data = await instance.post(`/downloads/csv-solicitation`, body);
    return data;
  }
}
